module.exports = __webpack_public_path__ + "img/AEXI_Logo.8a17ad10.png";